import React, { useState, useEffect } from 'react';
import { Table, Form } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';

const EstimateRepairsTable = ({ 
  selectedMobile, 
  repairs, 
  handleRepairCheckboxChange 
}) => {
  const [selectedRepairs, setSelectedRepairs] = useState({});

  const formatDate = (date) => {
    const d = new Date(date);
    // Convert to IST timezone
    const istDate = new Date(d.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    const day = String(istDate.getDate()).padStart(2, '0');
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const year = istDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Filter repairs based on selectedMobile and status
  const filteredRepairs = (repairs || []).filter(
    (repair) =>
      repair && 
      repair.mobile === selectedMobile &&
      repair.status === 'Receive from Workshop'
  );

  const handleCheckboxChange = (repair, isChecked) => {
    // Just toggle the selected state for display purposes
    setSelectedRepairs(prev => ({
      ...prev,
      [repair.repair_no]: isChecked
    }));
  };

  return (
    <div className="estimate-repairs-table" style={{ paddingBottom: "15px" }}>
      <h5>Repairs Table</h5>
      
      <div className="table-responsive">
        <Table bordered hover size="sm">
          <thead>
            <tr>
              <th>Select</th>
              <th>SI</th>
              <th>Date</th>
              <th>Repair No</th>
              <th>Mobile</th>
              <th>Account Name</th>
              <th>Item</th>
              <th>Metal Type</th>
              <th>Purity</th>
              <th>Qty</th>
              <th>Total Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredRepairs.length > 0 ? (
              filteredRepairs.map((repair, index) => (
                <tr key={repair.repair_no || index}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedRepairs[repair.repair_no] || false}
                      onChange={(e) => handleCheckboxChange(repair, e.target.checked)}
                    />
                  </td>
                  <td>{index + 1}</td>
                  <td>{formatDate(repair.date)}</td>
                  <td>{repair.repair_no}</td>
                  <td>{repair.mobile}</td>
                  <td>{repair.account_name}</td>
                  <td>{repair.item}</td>
                  <td>{repair.metal_type}</td>
                  <td>{repair.purity}</td>
                  <td>{repair.qty}</td>
                  <td>₹{repair.total_amt}</td>
                  <td>{repair.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="text-center">
                  No repairs found for this customer
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>


    </div>
  );
};

export default EstimateRepairsTable; 